module.exports = __webpack_public_path__ + "img/Weapon_02.7f6ccbfe.png";